import type { TranslationKeys } from './en'

export const it: TranslationKeys = {
  schoolSubtitle: 'Accedi tramite l\'app Agenda1',
  scanQrCode: 'Punta la fotocamera del tuo telefono sul codice QR',
  or: 'oppure',
  downloadApp: 'Scarica l\'app dai negozi ufficiali',
  appStoreBadgeUrl: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/it-it?size=250x83',
  appStoreBadgeAlt: 'Scarica su App Store',
  playStoreBadgeUrl: 'https://play.google.com/intl/it_it/badges/static/images/badges/it_badge_web_generic.png',
  playStoreBadgeAlt: 'Disponibile su Google Play',
  openAppStore: 'Apri su App Store',
  openPlayStore: 'Apri su Google Play',
  printQrCode: 'Stampa codice QR',
  schoolCode: 'Codice della scuola',
  scanInstruction: 'Punta la fotocamera del tuo telefono sul codice QR sopra',
  accessUrl: 'oppure accedi',
  needHelp: 'Hai bisogno di aiuto? Contatta il supporto',
  support: 'supporto@agenda1.app',
  copyright: `© ${new Date().getFullYear()} Agenda1. Tutti i diritti riservati.`,
  // Mobile 2-step flow
  step1Title: 'Scarica l\'App',
  step1Description: 'Se non ce l\'hai ancora, scarica Agenda1',
  step2Title: 'Apri la Scuola',
  step2Description: 'Tocca per aprire la scuola nell\'app',
  openSchoolButton: 'Apri Scuola nell\'App',
  alreadyHaveApp: 'Hai già l\'app?'
}
